import React, { useEffect } from "react";
import { Spin } from "antd";
import history from "../history.js";
import Loading from "../helperComponents/Loading";

const AuthenticatedLanding = ({ user }) => {
 useEffect(() => {
    if (user?.uid) {
      // Authenticated user - redirect to home
      history.replace("/home");
    } else {
      // Not authenticated - redirect to login
      history.replace("/login");
    }
  }, [user]);

  // Show minimal loading state during redirect
  return (
    <Loading/>
  );
};

export default AuthenticatedLanding;